/**
 * Element UI – Buy button form
 */
import config from './config'
import cpSite from './cpSite'
import { loadScript } from './loadScript'
import { waitModuleReady } from './waitModuleReady'

let init = false

const embedBuyForm = {
  depend: ['vue', 'element-ui'],
  state: {
    lib: config.DEVMODE ? ['js/embed-buy-form/ebbf.js'] : [config.THEME + 'js/embed-buy-form/ebbf.js'],
    isActive: false
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: embedBuyForm')
    }
    // Не проводить повторную инициализацию
    if (init) return

    // Критерий дальнейшего запуска
    const paths = [
      '/products/csp',
      '/products/csp/jcp',
      '/products/net',
      '/products/hsm',
      '/products/dss',
      '/products/ngate',
      '/products/ca',
      '/products/other/hm',
      '/products/pki-cluster',
      '/products/archive',
      '/products/ipsec',
      '/products/office/signature',
      '/products/other/cryptcp',
      '/products/other/pdf',
      '/products/spr40',
      '/products/smev-gateway',
      '/products/cades/ssf',
      '/products/hlf',
      '/products/other/secure-pack'
    ]
    if (cpSite.config.DEVMODE) {
      paths.push('/cryptopro.ru-themecol/page-downloads-csp.html')
    }

    // Если путь соответствует критерию
    if (matchesPath(paths)) {
      // Инициализация, но без повторов
      this.initialize(this)
      // Ожидание готовности новых скриптов
      waitModuleReady(() => (window.Vue && window.Vue.options.components?.ElButton), () => { this.embedButton() }, 30)
    } else if (cpSite.config.DEVMODE) {
      console.log('embedBuyForm: no path')
    }
    function matchesPath (paths) {
      for (const path of paths) {
        // Проверка на часть пути
        if (window.location.pathname.indexOf(path, 0) === 0) {
          // Полное соответствие
          if (path === window.location.pathname) {
            return true
          } else {
            // Частичное соответствие
            if (window.location.pathname.indexOf(path + '/', 0) === 0) {
              return true
            }
          }
        }
      }
      return false
    }
  },
  initialize () {
    cpSite.module.elementUi.activate()
    init = true
  },
  embedButton () {
    loadScript(this.state.lib[0])
    this.state.isActive = true
  }
}
export default embedBuyForm
